import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import studentRequest from 'utils/studentRequest'

export const SET_QUESTIONAIRE_GRAPHLIST = 'corporate/SET_QUESTIONAIRE_GRAPHLIST'
export const SET_INDIVIDUAL_DRAWER = `corporate/SET_INDIVIDUAL_DRAWER`
export const SET_QUESTION_AND_ANSWER = `SET_QUESTION_AND_ANSWER`
export const setQuestionaireGraphList = data => {
  return {
    type: SET_QUESTIONAIRE_GRAPHLIST,
    data,
  }
}
export const setIndividualDrawer = data => {
  return {
    type: SET_INDIVIDUAL_DRAWER,
    data,
  }
}
export const setQuestionAndAnswer = data => {
  return {
    type: SET_QUESTION_AND_ANSWER,
    data,
  }
}
export const getQuestionaireGraphList =
  ({ roleId, type }) =>
  async (dispatch, getState) => {
    let OverViewType = `type=${type}`
    try {
      const result = await studentRequest.get(
        `students/questionaire/roles/graphlist/${roleId}?${OverViewType}`
      )
      dispatch(setQuestionaireGraphList(result?.data?.data || {}))
      return result
    } catch (error) {
      dispatch(setQuestionaireGraphList({}))
      ErrorMessage(error?.message)
    }
  }

export const getQuestionAndAnswerList =
  ({ studentId, roleId }) =>
  async (dispatch, getState) => {
    try {
      const result = await studentRequest.get(
        `/students/${studentId}/role/${roleId}/questions/list`
      )

      dispatch(setQuestionAndAnswer(result?.data?.data || {}))
      return result
    } catch (error) {
      dispatch(setQuestionAndAnswer({}))
      ErrorMessage(error?.message)
      return error
    }
  }

export const getIndividualDrawerList =
  ({
    roleId,
    questionId,
    status,
    search,
    sortBy,
    orderBy,
    pageNum = 1,
    candidateFilterData,
    setLoading,
  }) =>
  async (dispatch, getState) => {
    setLoading(true)
    const searchValue = search ? `&searchBy=${search}` : ''
    const sort = sortBy ? `&sort=${sortBy}` : ''
    const order = orderBy ? `&order=${orderBy}` : ''
    const pageNo = Number(pageNum) - 1
    const applied = candidateFilterData?.status?.toString()
      ? `&isApplied=${candidateFilterData?.status}`
      : ''
    const fromRating = candidateFilterData?.rating?.minValue?.toString()
      ? `&fromRating=${candidateFilterData?.rating?.minValue}`
      : ''
    const toRating = candidateFilterData?.rating?.maxValue?.toString()
      ? `&toRating=${candidateFilterData?.rating?.maxValue}`
      : ''

    try {
      const result = await studentRequest.get(
        `students/role/${roleId}/studentquestionairelist?pageNo=${pageNo}&pageLimit=10&questionaireIds=${questionId}&questionStatus=${status}${searchValue}${sort}${order}${applied}${fromRating}${toRating}`
      )

      dispatch(setIndividualDrawer(result?.data?.data || {}))
      setLoading(false)
      return result
    } catch (error) {
      setLoading(false)
      dispatch(setIndividualDrawer({}))
      ErrorMessage(error?.message)
    }
  }
